module.exports = __webpack_public_path__ + "res/img_flip_counter.1b0cc111d970b8c7aaf6a610cbc393fd.png";